import i18nRouteMeta from '@/app-core/mixins/i18n/i18nRouteMeta'
import {HmacMD5} from '@/app-core/lib/crypto/crypto'
import API from '@/app-core/api/Api'
import BrandSlider from '@/app-theme/views/home/BrandSlider.vue'
import AutoUpdateApiData from '@/app-core/mixins/api/autoUpdateApiData'
import OrderStatusEnum from '@/app-core/api/enums/OrderStatusEnum'
import {toLocaleUpperCase} from '@/app-core/lib/helpers'
import StoreCommon from '@/app-core/mixins/store/storeCommon'

export default {
  name      : 'CheckoutFailure',
  components: {BrandSlider},
  directives: {},
  mixins    : [i18nRouteMeta, AutoUpdateApiData, StoreCommon],
  props     : {
    orderId: {
      type   : [Number, String],
      default: undefined
    }
  },
  enums    : {OrderStatusEnum},
  dataStore: {
    AppCart  : 'App.Cart',
    AppStores: 'App.Stores'
  },
  data() {
    return {
      isLoading : true,
      showData  : false,
      orderFound: false,
      orders    : [],
      orderCode : ''
    }
  },
  computed: {},
  watch   : {},
  beforeCreate() {
  },
  created() {
    const storageKey = HmacMD5.hash('ORDERID')
    this.$sessionStorage.remove(storageKey)

    if (this.orderId && this.orderId !== '0') {
      this.getData()
    } else {
      this.showData = true
    }
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    toLocaleUpperCase,
    getData() {
      if (!this.orderId || this.orderId === '0') return

      this.isLoading = true

      const payload = {
        OrderId         : this.orderId,
        PaymentOrderCode: this.$route.params.paymentOrderCode || '',
        PaymentEventId  : this.$route.params.paymentEventId || ''
      }

      API.Resource.Checkout.Failure(payload)
        .then(response => {
          if (API.isResponseSuccess(response)) {
            this.orderFound = true
            const data = API.responseData(response)
            this.orders = data.Stores
            this.orderCode = data.Code
          }
        })
        .catch(e => {
        })
        .finally(() => {
          this.isLoading = false
          this.showData = true
        })
    },

    getOrderStatusById(statusId) {
      const statuses = this.$te('Cart.OrderStatus') ? this.$t('Cart.OrderStatus') : []

      return statuses.find(status => status.Id === statusId)
    },

    getOrderStatusNameById(statusId) {
      return this.getOrderStatusById(statusId)?.Name || ''
    },

    getOrderStatusColorById(statusId) {
      return this.getOrderStatusById(statusId)?.Color || ''
    }
  }
}
